<template>
  <div>
    <div
      v-if="label === 'A-GRADE'"
      class="text-green-500 border border-green-500 rounded uppercase inline-block mx-auto px-2 py-0.5 text-3xs font-bold lg:text-2xs lg:bg-green-500 lg:border-0 lg:absolute lg:top-2 lg:right-2 lg:text-white lg:pt-1 lg:pb-0.5"
    >
      a-grade
    </div>
    <div
      v-if="label === 'B-GRADE'"
      class="text-sky-400 border border-sky-400 rounded uppercase inline-block mx-auto px-2 py-0.5 text-3xs font-bold lg:text-2xs lg:bg-sky-400 lg:border-0 lg:absolute lg:top-2 lg:right-2 lg:text-white lg:pt-1 lg:pb-0.5"
    >
      b-grade
    </div>
    <div
      v-if="label === 'C-GRADE'"
      class="text-orange-500 border border-orange-500 rounded uppercase inline-block mx-auto px-2 py-0.5 text-3xs font-bold lg:text-2xs lg:bg-orange-500 lg:border-0 lg:absolute lg:top-2 lg:right-2 lg:text-white lg:pt-1 lg:pb-0.5"
    >
      c-grade
    </div>
    <div
      v-if="label === 'D-GRADE'"
      class="text-red-500 border border-red-500 rounded uppercase inline-block mx-auto px-2 py-0.5 text-3xs font-bold lg:text-2xs lg:bg-red-500 lg:border-0 lg:absolute lg:top-2 lg:right-2 lg:text-white lg:pt-1 lg:pb-0.5"
    >
      d-grade
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
